var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-fade-transition',[(_vm.loading)?_c('v-overlay',{attrs:{"absolute":""}},[_c('v-progress-circular',{attrs:{"indeterminate":""}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }